var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents_rule"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.settingDate.config.shareholder_agreement)}})])}
var staticRenderFns = []

export { render, staticRenderFns }